import React from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../../contexts/auth/AuthContext';
import RouteRecovery from '../../routing/RouteRecovery';

const RequireAdmin = ({ children }) => {
  const { user } = useAuth();

  return user?.role === 'admin' ? children : <RouteRecovery variant="denied" />;
};

RequireAdmin.propTypes = {
  children: PropTypes.node.isRequired
};

export default RequireAdmin;
